import api from './api';

const genAIAdminToken = process.env.REACT_APP_GENAI_ADMIN_SECURITY_TOKEN;

const CreditManagementApi = {
  getCreditPackages: (params) =>
    api.get('/genai-admin/tool-pricing', {
      params,
      headers: { 'secure-token': genAIAdminToken },
    }),
  getCreditPackage: (id) =>
    api.get(`/genai-admin/tool-pricing/${id}`, {
      headers: { 'secure-token': genAIAdminToken },
    }),
  createCreditPackage: (data) =>
    api.post('/genai-admin/tool-pricing', data, {
      headers: { 'secure-token': genAIAdminToken },
    }),
  updateCreditPackage: (id, data) =>
    api.put(`/genai-admin/tool-pricing/${id}`, data, {
      headers: { 'secure-token': genAIAdminToken },
    }),
  updateCreditPackageStatus: (id, data) =>
    api.patch(`/genai-admin/tool-pricing/${id}/status`, data, {
      headers: { 'secure-token': genAIAdminToken },
    }),
  deleteCreditPackage: (id) =>
    api.delete(`/genai-admin/tool-pricing/${id}`, {
      headers: { 'secure-token': genAIAdminToken },
    }),
  searchTools: (params) =>
    api.get('/genai-admin/tools', {
      params,
      headers: { 'secure-token': genAIAdminToken },
    }),
};

export default CreditManagementApi;
